@if (display) {
	<p-dialog [styleClass]="authenticationService?.user?.fontSize === 'SMALL' ? 'custom-form-small' : (authenticationService?.user?.fontSize === 'MEDIUM' ? 'custom-form-medium' : '')"
		header="{{ title | uppercase }}"
		[(visible)]="display"
		[responsive]="true"
		showEffect="fade"
		[modal]="true"
		appendTo="body"
		[style]="{ width: '75vw' }"
		[breakpoints]="{ '1199px': '85vw', '575px': '95vw' }"
	>
<div [ngClass]="{'custom-form-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-form-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
		<!-- #region BODY -->
		<div class="container-fluid">
			<div #errorContainer>
				@if (errorMessages.length !== 0) {
					<div>
						@for (error of errorMessages; track error) {
							<div>
								<div class="alert alert-warning" role="alert">{{ error }}</div>
							</div>
						}
					</div>
				}
			</div>
			<div class="ui-grid-row">
				<div class="ui-grid-col-12">
					<p-messages [(value)]="messages"></p-messages>
				</div>
			</div>
			<div class="row mt-4 mb-4">
				<div class="col-sm-4">
					<label for="vehicle" class="form-label custom-label fw-bold small mb-2 me-2" i18n
						><strong>{{ 'general.vehicle' | translate }} (*) </strong></label
					>
					<div class="p-0"></div>
					<p-select
						[options]="vehicleList"
						[(ngModel)]="entity.vehicle"
						dataKey="id"
						optionLabel="name"
						placeholder="{{ 'general.select' | translate }} {{ 'general.vehicle' | translate }}"
						[style]="{ width: '100%' }"
						appendTo="body"
						[filter]="true"
						(onChange)="onChangeVehicle($event)"
						(onFilter)="onFilterVehicle($event)"
						[disabled]="!formManipulation || !editVehicle"
					>
					</p-select>
				</div>
				<div class="col-sm-4">
					<label for="fine-name" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						<strong>{{ 'tableManagement.fine.driver' | translate }} (*)</strong>
					</label>
					<div class="p-0"></div>
					<p-select
						[options]="driverList"
						[(ngModel)]="entity.driver"
						placeholder="{{ 'general.select' | translate }} {{ 'tableManagement.sinister.driver' | translate }}"
						dataKey="id"
						optionLabel="formatDriverLabel"
						[style]="{ width: '100%' }"
						appendTo="body"
						[filter]="true"
						(onChange)="onChangeDriver($event)"
						(onFilter)="onFilterDriver($event)"
						[disabled]="!formManipulation"
					>
						<ng-template let-driver pTemplate="item">
							<div class="flex align-items-center gap-2">
								<div>
									({{ driver.employee.code }}) {{ driver.employee.user.surname1 }}
									{{ driver.employee.user.surname2 }} {{ driver.employee.user.name }}
								</div>
							</div>
						</ng-template>
					</p-select>
				</div>
				<div class="col-sm-4">
					<label for="provider" class="form-label custom-label fw-bold small mb-2 me-2" i18n>{{
						'tableManagement.rentingTypes.rentingType' | translate
					}}</label>
					<div class="p-0"></div>
					<p-select
						[options]="providerList"
						[(ngModel)]="entity.provider"
						dataKey="id"
						optionLabel="name"
						placeholder="{{ 'general.select' | translate }} {{
							'tableManagement.rentingTypes.rentingType' | translate
						}}"
						[style]="{ width: '100%' }"
						appendTo="body"
						[filter]="true"
						(onChange)="onChangeProvider($event)"
						(onFilter)="onFilterProvider($event)"
						[disabled]="!formManipulation"
					>
					</p-select>
				</div>
			</div>
			<div class="row mt-4 mb-4">
				<div class="col-sm-4">
					<label for="billingAccount" class="form-label custom-label fw-bold small mb-2 me-2" i18n>{{
						'tableManagement.companies.company' | translate
					}}</label>
					<div class="p-0"></div>
					<p-select
						[options]="billingAccountList"
						[(ngModel)]="entity.billingAccount"
						dataKey="id"
						optionLabel="name"
						placeholder="{{ 'general.select' | translate }} {{ 'tableManagement.companies.company' | translate }}"
						[style]="{ width: '100%' }"
						appendTo="body"
						[filter]="true"
						(onChange)="onChangeBillingAccount($event)"
						(onFilter)="onFilterBillingAccount($event)"
						[disabled]="!formManipulation"
					>
					</p-select>
				</div>
				<div class="col-sm-4">
					<label for="delegation" class="form-label custom-label fw-bold small mb-2 me-2" i18n>{{
						'tableManagement.delegations.delegation' | translate
					}}</label>
					<div class="p-0"></div>
					<p-select
						[options]="delegationList"
						[(ngModel)]="entity.delegation"
						dataKey="id"
						optionLabel="name"
						placeholder="{{ 'general.select' | translate }} {{
							'tableManagement.delegations.delegation' | translate
						}}"
						[style]="{ width: '100%' }"
						appendTo="body"
						[filter]="true"
						(onChange)="onChangeDelegation($event)"
						(onFilter)="onFilterDelegation($event)"
						[disabled]="!formManipulation"
					>
					</p-select>
				</div>
				<div class="col-sm-4">
					<label for="breakdownReason" class="form-label custom-label fw-bold small mb-2 me-2" i18n
						><strong>{{ 'tableManagement.breakdown.breakdownReason.title' | translate }} (*)</strong></label
					>
					<div class="p-0"></div>
					<p-select
						[options]="breakdownReasonList"
						[(ngModel)]="entity.breakdownReason"
						dataKey="id"
						optionLabel="reason"
						placeholder="{{ 'general.select' | translate }} {{
							'tableManagement.breakdown.breakdownReason.title' | translate
						}}"
						[style]="{ width: '100%' }"
						appendTo="body"
						[filter]="true"
						(onChange)="onChangeBreakdownReason($event)"
						(onFilter)="onFilterBreakdownReason($event)"
						[disabled]="!formManipulation"
					>
					</p-select>
				</div>
			</div>
			<div class="row mt-4 mb-4">
				<div class="col-sm-4">
					<label for="uneconomical" class="form-label custom-label fw-bold small mb-2 me-2" i18n>{{
						'tableManagement.breakdown.uneconomical' | translate
					}}</label>
					<div class="p-0"></div>
					<p-toggleSwitch [(ngModel)]="entity.uneconomical" [disabled]="!formManipulation"></p-toggleSwitch>
				</div>
				<div class="col-sm-4">
					<label for="driverNegligence" class="form-label custom-label fw-bold small mb-2 me-2" i18n>{{
						'tableManagement.breakdown.negligence' | translate
					}}</label>
					<div class="p-0"></div>
					<p-toggleSwitch [(ngModel)]="entity.driverNegligence" [disabled]="!formManipulation"></p-toggleSwitch>
				</div>
				<div class="col-sm-4">
					<label for="closed" class="form-label custom-label fw-bold small mb-2 me-2" i18n>{{
						'tableManagement.breakdown.closed' | translate
					}}</label>
					<div class="p-0"></div>
					<p-toggleSwitch [(ngModel)]="entity.closed" [disabled]="!formManipulation"></p-toggleSwitch>
				</div>
			</div>
			<div class="container-fluid p-0 custom-panel">
				<!-- #region ROW 1: SINISTER NAV TABS -->
				<div class="row m-0 mt-4">
					<ul class="nav nav-tabs custom-nav-tabs">
						<li class="nav-item">
							<a
								href="#breakdownWorkshops"
								class="nav-link active p-0 custom-title custom-tab-title first-nav-tab"
								data-bs-toggle="tab"
							>
								<div class="d-flex align-items-center justify-content-center h-100">
									{{ 'tableManagement.sinister.workshop.title' | translate }}
								</div>
							</a>
						</li>
						@if (!isNew) {
							<li class="nav-item">
								<a
									href="#breakdownFollowings"
									class="nav-link p-0 custom-title custom-tab-title"
									data-bs-toggle="tab"
								>
									<div class="d-flex align-items-center justify-content-center h-100">
										{{ 'tableManagement.breakdown.breakdownFollowing.title' | translate }}
									</div>
								</a>
							</li>
						}
						@if (!isNew) {
							<li class="nav-item">
								<a
									href="#breakdownObservations"
									class="nav-link p-0 custom-title custom-tab-title"
									data-bs-toggle="tab"
								>
									<div class="d-flex align-items-center justify-content-center h-100">
										{{ 'tableManagement.sinister.sinisterObservations' | translate }}
									</div>
								</a>
							</li>
						}
						@if (!isNew) {
							<li class="nav-item">
								<a
									href="#breakdownDocuments"
									class="nav-link p-0 custom-title custom-tab-title"
									data-bs-toggle="tab"
								>
									<div class="d-flex align-items-center justify-content-center h-100">
										{{ 'drivers.form.documents' | translate }}
									</div>
								</a>
							</li>
						}
					</ul>
				</div>
				<!-- WORKSHOP TAB CONTENT -->
				<div class="row m-0">
					<div class="tab-content p-0">
						<div class="tab-pane fade show active" id="breakdownWorkshops">
							<div class="container-fluid">
								<div class="row mt-4 mb-4">
									<div class="col-sm-4">
										<label for="workshop" class="form-label custom-label fw-bold small mb-2 me-2" i18n>{{
											'tableManagement.sinister.workshop.title' | translate
										}}</label>
										<div class="p-0"></div>
										<div class="d-flex align-items-center gap-2 w-100">
										<p-select
											[options]="workshopList"
											[(ngModel)]="entity.workshop"
											dataKey="id"
											placeholder="{{ 'general.select' | translate }} {{
												'tableManagement.sinister.workshop.title' | translate
											}}"
											optionLabel="name"
											[style]="{ flex: '1 1 auto', width: '1%' }"
											appendTo="body"
											[filter]="true"
											(onChange)="onChangeWorkshop($event)"
											(onFilter)="onFilterWorkshop($event)"
											[disabled]="!formManipulation"
										>
										</p-select>
										<button
											class="btn custom-expand-button"
											type="button"
											i18n-alt alt="{{'tableManagement.sinister.workshop.createWorkshop' | translate}}"
											(click)="addWorkshop()"
										>
											<svg-icon
												class="d-flex m-0 p-0 custom-expand-button-icon"
												src="assets/icons/add.svg"
												[svgStyle]="{ 'height.px': 25, 'width.px': 25 }"
											></svg-icon>
										</button>
										</div>
									</div>
									<div class="col-sm-4">
										<label for="startDateWorkshop" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
											{{ 'tableManagement.sinister.workshopStartDate' | translate }}
										</label>
										<div class="p-0"></div>
										<p-datepicker
											[(ngModel)]="startDateWorkshop"
											[showTime]="false"
											[style]="{ width: '100%' }"
											dateFormat="{{ i18n.dateFormat }}"
											showIcon="true"
											appendTo="body"
											[disabled]="!formManipulation"
										></p-datepicker>
									</div>
									<div class="col-sm-4">
										<label for="endDateWorkshop" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
											{{ 'tableManagement.sinister.workshopEndDate' | translate }}
										</label>
										<div class="p-0"></div>
										<p-datepicker
											[(ngModel)]="endDateWorkshop"
											[showTime]="false"
											[style]="{ width: '100%' }"
											dateFormat="{{ i18n.dateFormat }}"
											showIcon="true"
											appendTo="body"
											[disabled]="!formManipulation"
										></p-datepicker>
									</div>
								</div>
							</div>
						</div>
						<!-- BREAKDOWN FOLLOWING TAB CONTENT -->
						<div class="tab-pane fade" id="breakdownFollowings">
							<div class="container-fluid">
								@if (!isNew) {
									<div class="row mt-3">
										<app-breakdown-following-list [breakdown]="entity"></app-breakdown-following-list>
									</div>
								}
							</div>
						</div>
						<!-- OBSERVATIONS TAB CONTENT -->
						<div class="tab-pane fade" id="breakdownObservations">
							<div class="container-fluid">
								@if (!isNew) {
									<div class="row mt-3">
										<app-observations-list
											[type]="observationType"
											[entityId]="entity.id"
											[ids]="idsObservations"
										></app-observations-list>
									</div>
								}
							</div>
						</div>
						<!-- DOCUMENTS TAB CONTENT -->
						<div class="tab-pane fade" id="breakdownDocuments">
							<div class="container-fluid">
								<!-- taula de documents -->
								@if (!isNew) {
									<div class="row mt-3">
										<app-doc-table
											type="breakdown"
											[entity]="entity"
											[nested]="true"
											[ids]="ids"
											(return)="refresh()"
										>
										</app-doc-table>
									</div>
								}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- #endregion BODY -->
	</div>
<!-- #region FOOTER -->
<ng-template pTemplate="footer">
			<div class="d-flex justify-content-center bd-highlight">
				<div class="p-2 bd-highlight">
					@if (isNew) {
						<div>
							<button class="btn custom-button" (click)="saveChanges()" [disabled]="!formManipulation" i18n>
								{{ 'general.create' | translate }}
							</button>
						</div>
					}
					@if (!isNew) {
						<div>
							<button class="btn custom-button" (click)="saveChanges()" [disabled]="!formManipulation" i18n>
								{{ 'general.save' | translate }}
							</button>
						</div>
					}
				</div>
			</div>
		</ng-template>
<!-- #endregion FOOTER -->
</p-dialog>
}

<app-workshop-form></app-workshop-form>

